// signin.component.ts
import { Component, OnInit } from '@angular/core';
import { MsalService } from '../msal.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {

  constructor(private msalService: MsalService,private router: Router) { }
  ngOnInit(): void {
    this.msalService.checkIfLoggedIn();
    console.log(this.msalService.isLoggedIn)
    if(this.msalService.isLoggedIn == true){
        // Write code to redirect to transaction-runner without asking for login
         this.router.navigate(['/transaction-runner']);    }
  }

  signIn() {
    // this.msalService.initializeMsal();
      this.msalService.login();
  }
}
